/* eslint-disable */
import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const Pagination = ({ formData }) => {
    if (!formData?.data?.length) {
        return null;
    }
    const { current_page, last_page, first_page_url, next_page_url, prev_page_url } = formData;

    const renderPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= last_page; i++) {
            pageNumbers.push(
                <li key={i} className={`page-item ${current_page === i ? 'active' : ''}`}>
                    <Link className="page-link" to={`?page=${i}`}>
                        {i} {current_page === i && <span className="sr-only">(current)</span>}
                    </Link>
                </li>
            );
        }
        return pageNumbers;
    };

    const cleanUrl = (url) => {
        if (url) {
            return url.replace('software-exchange-be.test/api', 'localhost:3000'); // Replace 'example.com' with the part you want to hide
        }
        return '';
    };

    return (
        <div className="site-pagination mt-4 s-p-center">
            <ul className="pagination">
                <li className={`page-item ${current_page === 1 ? 'disabled' : ''}`}>
                    <Link className="page-link" to={cleanUrl(prev_page_url) || '#'} tabIndex={current_page === 1 ? -1 : 0}>
                        <FaChevronLeft />
                    </Link>
                </li>
                {renderPageNumbers()}
                <li className={`page-item ${current_page === last_page ? 'disabled' : ''}`}>
                    <Link className="page-link" to={cleanUrl(next_page_url) || '#'} tabIndex={current_page === last_page ? -1 : 0}>
                        <FaChevronRight />
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default Pagination;
